import React from "react";
import { buildResultList } from "@coveo/headless";
import classNames from "classnames";
import { InteractiveResult } from "./InteractiveResult";
import { useCoveoController } from "./utils";
import { Pager } from "./Pager";

export const ResultsList = () => {
  const { state, headlessEngine } = useCoveoController(
    (headlessEngine) =>
      buildResultList(headlessEngine, {
        options: {
          fieldsToInclude: [
            // the friendly name for the source of the article (i.e. Blog, Docs, Knowledge, and so on)
            "commonsource"
          ]
        }
      }),
    "ResultsList"
  );

  const { results, hasResults, firstSearchExecuted, isLoading, hasError } = state;

  if (!firstSearchExecuted && !hasResults && hasError) {
    return null;
  }

  return (
    <div className={classNames("results-list", { loading: isLoading })}>
      <ul>
        {results.map((result) => (
          <li key={result.uniqueId}>
            <article>
              <InteractiveResult result={result} headlessEngine={headlessEngine} />
              <p>{result.excerpt}</p>
            </article>
          </li>
        ))}
      </ul>
      <Pager />
    </div>
  );
};
